import { useState } from 'react';
import { useContextAdminHora } from '../ContextAdminHorario';
import { adiDetalleHorario } from '../../../services/HorarioTurno/TurnoService';

export const useNuevoDetalleHorario = (horarioId, ocultaDialogNuevo) => {
    const [horaIni, setHoraIni] = useState(new Date());
    const [horaFin, setHoraFin] = useState(new Date());

    const [habilita, setHabilita] = useState(false);
    const [esNocturno, setEsNocturno] = useState(false);

    const showToast = useContextAdminHora();

    const formatHora = (fechaHora) => {
        if (!fechaHora) return '';

        const hora = String(fechaHora.getHours()).padStart(2, '0');
        const minuto = String(fechaHora.getMinutes()).padStart(2, '0');

        return `${hora}:${minuto}:00`;
    };

    const registraDetalle = async () => {
        const esValido = esNocturno ? horaIni > horaFin : horaIni <= horaFin;
        if (!esValido) {
            showToast('warn', 'Warning', esNocturno ? 'Hora Fin debe ser menor a hora Fin' : 'Hora Inicio debe ser menor a Hora Fin');
            return;
        }

        const objetoPost = {
            horarioId: horarioId,
            horaInicio: formatHora(horaIni),
            horaFin: formatHora(horaFin),
            esNocturno: esNocturno
        };
        setHabilita(true);
        try {
            const response = await adiDetalleHorario(objetoPost);
            //console.log('kk12', response);
            if (response.horarioDetalleId) {
                showToast('success', 'Success', 'Horario creado con exito');
            }
        } catch (error) {
            showToast('error', 'Error', 'Se ha producido un Error al crear');
            console.error(error.message);
        } finally {
            ocultaDialogNuevo();
            setHabilita(false);
        }
    };
    return { horaIni, horaFin, esNocturno, habilita, setHoraIni, setHoraFin, setEsNocturno, registraDetalle };
};
